

var winWidth = $(window).width();

function isTouchDevice() {
  return (('ontouchstart' in window) ||
     (navigator.maxTouchPoints > 0) ||
     (navigator.msMaxTouchPoints > 0));
}

if ( isTouchDevice() ) {
  $('html').addClass('is-touch');
}

function spanRight() {

  $('.span-right.wp-block-column').each(function(i) {

    if ( winWidth > 991 ) { 

      var colOffset = $(this).offset();
      var group  = $(this).parent().closest('.wp-block-group__inner-container');
      var width  = group.outerWidth();
      var height = group.outerHeight();
      var elWidth = $(this).innerWidth();
      //console.log(elWidth);
      var rightMargin = (winWidth - width) / 2;
      //console.log(rightMargin);
      var newElWidth = elWidth + rightMargin;
      //console.log(newElWidth);
      width = typeof elWidth !== undefined ? width / elWidth : width / 2;
      var child = $(this).children().addClass('is-spanning').css({'max-width':'9999px','width': newElWidth,'margin-right': (-1 * rightMargin)});

    }

  });

};

function spanLeft() {

  $('.span-left.wp-block-column').each(function(i) {

    if ( winWidth > 991 ) { 

      var colOffset = $(this).offset();
      var group  = $(this).parent().closest('.wp-block-group__inner-container');
      var width  = group.outerWidth();
      var height = group.outerHeight();
      var elWidth = $(this).innerWidth();
      //console.log(elWidth);
      var leftMargin = (winWidth - width) / 2;
      //console.log(leftMargin);
      var newElWidth = elWidth + leftMargin;
      //console.log(newElWidth);
      width = typeof elWidth !== undefined ? width / elWidth : width / 2;
      var child = $(this).children().addClass('is-spanning').css({'max-width':'9999px','width': newElWidth,'margin-left': (-1 * leftMargin)});

    }

  });

};

function spanRightSquare() {

  $('.span-right-square.wp-block-column').each(function(i) {

    if ( winWidth > 991 ) { 

      var columns = $(this).closest('.wp-block-columns');
      var columnsWidth = columns.outerWidth();
      //console.log(columnsWidth);
      //colOffset = colOffset - 30;
      var group  = $(this).parent().closest('.wp-block-group');
      var groupWidth  = group.outerWidth();
      var groupHeight = group.outerHeight();
      var elWidth = $(this).data('width');
      var rightMargin = (groupWidth - columnsWidth) / 2;
      //console.log(rightMargin);
      var calcWidth = elWidth ? groupWidth / elWidth : groupWidth / 2;
      //width = width + 30;

      var child = $(this).children().addClass('is-spanning').css({'max-width':'9999px','height': calcWidth,'width': calcWidth});

    }

  });

};


function spanLeftSquare() {

  $('.span-left-square.wp-block-column').each(function(i) {

    if ( winWidth > 991 ) { 

      var columns = $(this).closest('.wp-block-columns');
      var columnsWidth = columns.outerWidth();
      //console.log(columnsWidth);
      //colOffset = colOffset - 30;
      var group  = $(this).parent().closest('.wp-block-group');
      var groupWidth  = group.outerWidth();
      var groupHeight = group.outerHeight();
      var elWidth = $(this).data('width');
      var leftMargin = (groupWidth - columnsWidth) / 2;
      //console.log(rightMargin);
      var calcWidth = elWidth ? groupWidth / elWidth : groupWidth / 2;
      //width = width + 30;

      var child = $(this).children().addClass('is-spanning').css({'max-width':'9999px','width': calcWidth,'margin-left':-1 * leftMargin});


      // var colOffset = $(this).offset();
      // var group  = $(this).parent().closest('.wp-block-group');
      // var width  = group.outerWidth();
      // var height = group.outerHeight();
      // var elWidth = $(this).data('width');
      // width = elWidth ? width / elWidth : width / 2;
      // var child = $(this).children().addClass('is-spanning').css({'max-width':'9999px','height': width,'width': width,'margin-left':(-1 * colOffset.left)});

    }

  });

};

spanRight();
spanRightSquare();
spanLeft();
spanLeftSquare();

addEventListener("resize", (event) => {
  spanRight();
  spanRightSquare();
  spanLeft();
  spanLeftSquare();
});

$('.nav-search > a').on('click', function(e) {
  e.preventDefault();
  $('.banner').toggleClass('is-searching');
  $('.nav-search').toggleClass('is-showing');
  $('.menu-item').not('.nav-search').toggleClass('is-hiding');
});

$('.back-to-top').on('click', function(e) {

  e.preventDefault();
  $('html, body').animate({
    scrollTop: 0
  }, 750);

});

// Add class to body on hamburger click
$('.navbar-toggler').on('click', function(e) {
  e.preventDefault();
  $('body').toggleClass('menu-is-open');

  if (!$('body').hasClass('menu-is-open')) {
    $('.banner').removeClass('is-searching');
    $('.nav-search').removeClass('is-showing');
    $('.menu-item').not('.nav-search').removeClass('is-hiding');
  }
});

// if ( $('.menu-item.dropdown').length > 0 ) {

//   $('.menu-item.dropdown').on('click', function(e) {

//     if ( winWidth < 1200 ) {

//       if ( $(this).hasClass('is-expanded') ) {
//         $(this).removeClass('is-expanded');
//       } else {
//         $(this).addClass('is-expanded');
//       }

//     }

//   });

// }

$('.ginput_container input:not(:file), .ginput_container textarea').on('focusout', function(e) {

  var thisVal = $(this).val();

  if (thisVal) {
    $(this).parent().addClass('has-value');
  } else {
    $(this).parent().removeClass('has-value');
  }

});

if ( $('.blank').length > 0 ) {

  $('.blank').each( function(index, value) {
    $(this).find('a').attr('target','_blank').attr('rel','external noreferrer noopener');
  });

}
